import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import styles from "./adminPanelOne.module.scss";
import SideNav from "../sideNav/SideNav";
import { connect, useSelector, useDispatch } from "react-redux";

import {
  IconButton,
  useMediaQuery,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Popover,
  Badge,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  dispatcherNavigations,
  packagerNavigations,
  superAdminNavigations,
} from "../../data/NavigationData";
import { loginUserResponse } from "../../store/actions";
import { setCookie } from "../../utils/common/cookies";
import { Col } from "react-bootstrap";
import { axiosGet } from "../../utils/common/axios";
import {
  NotificationsActive,
  NotificationsNoneOutlined,
} from "@mui/icons-material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import NotificationComponent from "../../components/customComponents/notificationComponent/NotificationComponent";

const getNavigations = (role = "") => {
  console.log(role, "role");
  switch (role) {
    case "super-admin":
      return superAdminNavigations;
    case "dispatcher":
      return dispatcherNavigations;
    case "packager":
      return packagerNavigations;

    default:
      return superAdminNavigations;
  }
};

const AdminPanel = ({ user, product }) => {
  const navigate = useNavigate();
  const panel = useSelector((state) => state?.ui?.panel);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationsAnchorEl, setNotificationsAnchorEl] = useState(null);

  useEffect(() => {
    if (!user?.id) {
      navigate("/login");
    }
  }, [user]);

  useEffect(() => {
    if (isDesktop && mobileNavOpen) {
      setMobileNavOpen(false);
    }
  }, [isDesktop, mobileNavOpen]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    setCookie("token", null);
    setCookie("rmd", null);
    dispatch(loginUserResponse(null));
    handleClose();
    navigate("/login");
  };

  useEffect(() => {
    if (user?.role === "admin") {
      getOutOfStockNotification();
    }
  }, [user, product]);

  const getOutOfStockNotification = async () => {
    try {
      const { status, data } = await axiosGet("/product/out-of-stock");
      if (status === 200) {
        setNotifications(data);
      }
    } catch (error) {}
  };

  const notificationsCount = notifications?.length ?? 0;
  const hasNotifications = notificationsCount > 0;
  const isNotificationsOpen = Boolean(notificationsAnchorEl);
  const notificationsPopoverId = isNotificationsOpen
    ? "notifications-popover"
    : undefined;

  const handleNotificationsClick = (event) => {
    if (isNotificationsOpen) {
      setNotificationsAnchorEl(null);
      return;
    }

    setNotificationsAnchorEl(event.currentTarget);
  };

  const handleNotificationsClose = () => {
    setNotificationsAnchorEl(null);
  };
  console.log(user);

  return (
    <div className={styles.container}>
      <div className={styles.leftCol}>
        <SideNav
          mobileOpen={mobileNavOpen}
          onClose={() => setMobileNavOpen(false)}
          triggerLogout={handleClickOpen}
          navItems={getNavigations(user?.role)}
        />
      </div>
      <div
        className={`${styles.rightCol} ${
          panel?.show === true ? styles?.open : styles.closed
        }`}
      >
        <div className={styles.contentViewRow}>
          <div className={styles.contentView}>
            {!isDesktop && (
              <div className={styles.mobileNavTrigger}>
                <IconButton onClick={() => setMobileNavOpen(true)}>
                  <span className="material-symbols-outlined">menu</span>
                </IconButton>
              </div>
            )}
            <div className={styles.contentViewport}>
              <div className={styles.navControls}>
                <Col className={styles.muiIconContainer}>
                  {user?.role === "admin" && (
                    <IconButton
                      classes={{ root: styles.iconButton }}
                      aria-describedby={notificationsPopoverId}
                      onClick={handleNotificationsClick}
                      size="large"
                    >
                      <Badge
                        badgeContent={notificationsCount}
                        color="error"
                        overlap="rectangular"
                        invisible={!hasNotifications}
                      >
                        <>
                          {hasNotifications ? (
                            <NotificationsOutlinedIcon
                              classes={{ root: styles.muiIconActive }}
                              // color="error"
                              style={{ color: "rgba(26, 77, 77, 1) " }}
                            />
                          ) : (
                            <NotificationsNoneOutlined
                              classes={{ root: styles.muiIcon }}
                            />
                          )}
                        </>
                      </Badge>
                    </IconButton>
                  )}

                  <Popover
                    id={notificationsPopoverId}
                    open={isNotificationsOpen}
                    anchorEl={notificationsAnchorEl}
                    onClose={handleNotificationsClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    PaperProps={{
                      sx: {
                        boxShadow: "none",
                        background: "transparent",
                        overflow: "visible",
                        mt: 1,
                        p: 0,
                      },
                    }}
                  >
                    <NotificationComponent
                      notifications={notifications}
                      onClose={handleNotificationsClose}
                    />
                  </Popover>
                </Col>
                {location?.pathname !== "/" && (
                  <>
                    <IconButton
                      aria-label="Go back"
                      className={styles.navButton}
                      onClick={() => navigate(-1)}
                    >
                      <span class="material-symbols-outlined">
                        chevron_left
                      </span>
                    </IconButton>
                    <IconButton
                      aria-label="Go forward"
                      className={styles.navButton}
                      onClick={() => navigate(1)}
                    >
                      <span class="material-symbols-outlined">
                        chevron_right
                      </span>
                    </IconButton>
                  </>
                )}
              </div>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Alert"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to log out?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="error" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={handleLogout}
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.login?.user,
    product: state.product?.product,
  };
};

export default connect(mapStateToProps, null)(AdminPanel);
